import { render, staticRenderFns } from "./v-autocomplete.vue?vue&type=template&id=4ca5e462&scoped=true&"
import script from "./v-autocomplete.vue?vue&type=script&lang=js&"
export * from "./v-autocomplete.vue?vue&type=script&lang=js&"
import style0 from "./v-autocomplete.vue?vue&type=style&index=0&id=4ca5e462&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca5e462",
  null
  
)

export default component.exports